// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.course-item[data-v-68c61765] {\n  padding-bottom: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
